import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import logo from "../assets/snap4me_logo.png";
import logoCircle from "../assets/snap4me_logo_circle.png";
import "./Sidebar.css";

function Sidebar({ onLogout }) {
  const [collapsed, setCollapsed] = useState(false);

  const storedUser =
    localStorage.getItem("user") ||
    localStorage.getItem("localUser");

  let user = null;

  try {
    user = storedUser ? JSON.parse(storedUser) : null;
  } catch (error) {
    console.error("Failed to parse user information:", error);
  }

  const orgRole = user?.org_role?.toUpperCase() || "";
  const organizationType = user?.organization_type?.toUpperCase() || "";

  const isInternalAdmin =
    organizationType === "INTERNAL" && orgRole === "ADMIN";
  const isAppearanceAdmin =
    (organizationType === "INTERNAL" && orgRole === "ADMIN") ||
    (organizationType === "CUSTOMER" && orgRole === "ADMIN"); 

  const isJobMapUser =
    (organizationType === "INTERNAL" && orgRole === "ADMIN") ||
    (organizationType === "CUSTOMER" && orgRole === "ADMIN") ||
    (organizationType === "CUSTOMER" && orgRole === "BM");

  const menus = [
    {
      id: "reports",
      path: "/reports",
      title: "Reports",
      icon: "📊",
    },
    {
      id: "dashboard",
      path: "/dashboard",
      title: "Command Center",
      icon: "⌂",
    },
   
    {
      id: "users",
      path: "/users",
      title: "Users",
      icon: "👥",
    },
    {
      id: "brand-list",
      path: "/brand-list",
      title: "Brand List",
      icon: "🏢",
    },
    {
      id: "add-brand",
      path: "/add-brand",
      title: "Add Brand",
      icon: "🏷️",
    },
    {
      id: "campaign-list",
      path: "/campaign-list",
      title: "Campaign List",
      icon: "📋",
    },
    {
      id: "jobs-management",
      path: "/jobs-management",
      title: "Jobs Management",
      icon: "📑",
    },
    {
      id: "create-campaign",
      path: "/create-campaign",
      title: "Create Campaign",
      icon: "➕",
    },

    /* SNAPPER FEATURES - INTERNAL ADMIN ONLY */
    ...(isInternalAdmin
      ? [
          {
            id: "snapper-insight",
            path: "/snapper-insight",
            title: "Snapper Insight",
            icon: "📈",
          },
          {
            id: "snapper-list",
            path: "/snapper-list",
            title: "Snapper List",
            icon: "👤",
          },

                    {
            id: "aadhaar-verification",
            path: "/aadhaar-verification",
            title: "Aadhaar Verification",
            icon: "🪪",
          },
                  {
            id: "user-login-activity",
            path: "/user-login-activity",
            title: "User Login Activity",
            icon: "🔐",
        },
        ]
      : []),

    /* JOB MAP & JOB LIST - INTERNAL ADMIN, CUSTOMER ADMIN, CUSTOMER BM */
    ...(isJobMapUser
      ? [
          {
            id: "jobs-map",
            path: "/jobs-map",
            title: "Job Map",
            icon: "🗺️",
          },
          {
            id: "job-list",
            path: "/job-list",
            title: "Job List",
            icon: "📋",
          },

        ]
      : []),
      /* WALLET WITHDRAWALS - ALL INTERNAL USERS ONLY */
...(organizationType === "INTERNAL"
  ? [
      {
        id: "wallet-withdrawals",
        path: "/wallet-withdrawals",
        title: "Wallet Withdrawals",
        icon: "💰",
      },
    ]
  : []),
  ];

  return (
    <aside className={`sidebar ${collapsed ? "sidebar-collapsed" : ""}`}>
      <div className="sidebar-top">
        {/* =====================================================
            SIDEBAR HEADER
            Logo + minimize button on the SAME ROW
            ===================================================== */}
        <div className="sidebar-header">
          <div className="sidebar-brand-row">
            {/* Full logo when expanded */}
            {!collapsed && (
              <img
                src={logo}
                alt="Snap4Me"
                className="sidebar-logo"
              />
            )}

            {/* Circle logo when collapsed */}
            {collapsed && (
              <img
                src={logoCircle}
                alt="Snap4Me"
                className="sidebar-logo-circle"
              />
            )}

            {/* Minimize / Expand button */}
            <button
              type="button"
              className="sidebar-toggle"
              onClick={() => setCollapsed((prev) => !prev)}
              title={collapsed ? "Expand sidebar" : "Collapse sidebar"}
              aria-label={collapsed ? "Expand sidebar" : "Collapse sidebar"}
              aria-expanded={!collapsed}
            >
              {collapsed ? "›" : "‹"}
            </button>
          </div>

          {/* Organization Role Subtitle */}
          {!collapsed && (
            <p className="sidebar-subtitle">
              {orgRole || "USER"} PANEL
            </p>
          )}
        </div>

        {/* =====================================================
            SIDEBAR MENU
            ===================================================== */}
        <nav className="sidebar-menu">
          {menus.map((menu) => (
            <NavLink
              key={menu.id}
              to={menu.path}
              className={({ isActive }) =>
                `sidebar-item ${isActive ? "active" : ""}`
              }
            >
              <span className="sidebar-icon">{menu.icon}</span>

              {/* Normal expanded sidebar title */}
              {!collapsed && (
                <span className="sidebar-title">{menu.title}</span>
              )}

              {/* Collapsed sidebar tooltip */}
              {collapsed && (
                <span className="sidebar-tooltip">{menu.title}</span>
              )}
            </NavLink>
          ))}
        </nav>
      </div>

      {/* =====================================================
          LOGOUT BUTTON
          ===================================================== */}
      <button
        className="sidebar-logout"
        onClick={onLogout}
        title="Logout"
      >
        {collapsed ? "↪" : "Logout"}
      </button>
    </aside>
  );
}

export default Sidebar;